
export function getOpenOnClickDivs(){

    /**** 
    
        MUST BE CALLED ON AFTER THE RENDER FUNCTION HAS BEEN CALLED
        
    ****/
    
    
    return this.openOnClick_divs;

};
